var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.649 1.15a1.207 1.207 0 01-.849 2.057H1.221a1.196 1.196 0 01-1.128-.74A1.209 1.209 0 01.755.884c.148-.06.307-.089.466-.086H14.8c.318 0 .623.127.848.353z",
    fill: "#06C"
  })));
}
export default SvgFoldIn;